export class store_carousel_list_controller {
    constructor(private $rootScope) {
        "ngInject"
    }
    $onInit() {
        console.log(this);
        this.$rootScope.$emit('endLoading')
    }
}


// WEBPACK FOOTER //
// ./src/components/store-carousel-list/store-carousel-list.controller.ts